import { useState } from 'react';

import AuthStore from '@app/src/common/store/AuthStore';
import LocaleStore from '@app/src/common/store/LocaleStore';
import UserManagementRepository from '@app/src/common/repository/UserManagementRepository';
import NotificationService from '@app/src/services/notification-service/NotificationService';

const useHelpLink = (type: string) => {
  const [loading, setLoading] = useState(false);

  const onLinkOpen = () => {
    setLoading(true);
    return UserManagementRepository.getHelpUrl(AuthStore.companyId, {
      key: type,
      language: LocaleStore.locale
    })
      .then(result => {
        if (result.value) {
          window.open(result.value, '_blank');
        }
      })
      .catch(() => {
        NotificationService.errorMessage('notification.data.fetch.failed');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return {
    onLinkOpen,
    isLoading: loading
  };
};

export default useHelpLink;
